import { HttpInterceptorFn } from '@angular/common/http';
import {environment} from "../../../environments/environment";

export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
  const apiKey = environment.apiKey;

  // let headers = req.headers.set('Authorization', `Bearer ${apiKey}`);
  let headers = req.headers.set('Authorization', ``);

  const clonedRequest = req.clone({ headers });
  return next(clonedRequest);
};
